import styled from "styled-components";

export const Preco = styled.div`
  background-color: var(--blue-white);
  display: flex;
  justify-content: center;
  align-items: center;

  #pather-div {
    max-width: 1300px;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 43px;
    gap: 52px;

    #div-header {
      h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 122%;
        color: var(--title);
      }

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 160%;
        color: var(--orange);

        span {
          font-weight: 900;
        }
      }
    }

    #all-precos {
      display: flex;
      flex-direction: column;
      gap: 56px;

      .art-precos {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .description {
          border-bottom: 2px solid #d4e1f8;
          padding-bottom: 10px;
          p {
            font-size: 14px;
            line-height: 160%;
            color: var(--paragraph);

            span {
              font-weight: 900;
            }
          }
        }

        .desc-total {
          border-bottom: 2px solid #d4e1f8;
          padding-bottom: 10px;

          p {
            font-weight: 700;
            font-size: 14px;
            line-height: 160%;
            color: #0a9230;
          }
        }

        .precos {
          font-weight: 700;
          font-size: 20px;
          line-height: 160%;
          color: var(--orange);
        }
      }
    }
  }

  @media (min-width: 601px) {
    #pather-div {
      flex-direction: column;

      #div-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        h1 {
          font-size: 48px;
          line-height: 140%;
        }

        p {
          font-size: 16px;
          line-height: 160%;
          width: 35%;
        }
      }

      #all-precos {
        gap: 0;

        .art-precos {
          flex-direction: row;
          justify-content: space-between;
          border-bottom: 2px solid #d4e1f8;
          padding: 27px;

          .description, .desc-total {
            width: 80%;
            border: none;
            border-right: 2px solid #d4e1f8;

            p {
              width: 70%;
              font-size: 18px;
              line-height: 160%;
            }
          }

          .precos {
            font-size: 24px;
            line-height: 160%;
            margin: auto;
          }
        }
      }
    }
  }
`;
